const React = require('react');

export default class extends React.Component {
  static displayName = '106-PageRedirectHelp';

  //-----------------------------------------------------
  UNSAFE_componentWillMount() {
    return window.open('https://support.rfiddiscovery.com');
  }

  render() {
    return <br />;
  }
}
